<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 lg12>
        <v-card class="mb-4">
          <v-card-title primary-title>
            <v-layout>
              <v-flex>
                <div>
                  <h3 class="headline mb-0">Vendas</h3>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <bar-chart-vendas :dados="vendas" />
                <sem-informacoes v-if="vendas.length == 0" />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorFornecedor"
          :lista="listaVendasPorFornecedor"
          :totalQuantidade="totalQuantidadeVendasPorFornecedor"
          :totalValor="totalValorVendasPorFornecedor"
          :titulo="'Vendas por Fornecedor'"
        />
      </v-flex>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorCliente"
          :lista="listaVendasPorCliente"
          :totalQuantidade="totalQuantidadeVendasPorCliente"
          :totalValor="totalValorVendasPorCliente"
          :titulo="'Vendas por Cliente'"
        />
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorEstado"
          :lista="listaVendasPorEstado"
          :totalQuantidade="totalQuantidadeVendasPorEstado"
          :totalValor="totalValorVendasPorEstado"
          :titulo="'Vendas por Estado'"
        />
      </v-flex>
      <v-flex xs12 sm12 lg6>
        <grafico-template
          :dados="vendasPorRegiao"
          :lista="listaVendasPorRegiao"
          :totalQuantidade="totalQuantidadeVendasPorRegiao"
          :totalValor="totalValorVendasPorRegiao"
          :titulo="'Vendas por Região'"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServiceGraficos from "@/services/graficos";
import BarChartVendas from "./BarChartVendas.vue";
import GraficoTemplate from "./GraficoTemplate.vue";
import SemInformacoes from "./SemInformacoes.vue";

export default {
  name: "DashboardFornecedor",
  components: {
    BarChartVendas,
    GraficoTemplate,
    SemInformacoes,
  },
  data() {
    return {
      listaVendasPorFornecedor: [],
      listaVendasPorCliente: [],
      listaVendasPorEstado: [],
      listaVendasPorRegiao: [],

      vendas: [],
      vendasPorFornecedor: [],
      vendasPorCliente: [],
      vendasPorEstado: [],
      vendasPorRegiao: [],

      totalQuantidadeVendasPorFornecedor: 0,
      totalQuantidadeVendasPorCliente: 0,
      totalQuantidadeVendasPorEstado: 0,
      totalQuantidadeVendasPorRegiao: 0,

      totalValorVendasPorFornecedor: 0,
      totalValorVendasPorCliente: 0,
      totalValorVendasPorEstado: 0,
      totalValorVendasPorRegiao: 0,

      resposta: null,
      user: null,
      rodada: null,
    };
  },
  mounted() {
    this.user = this.$auth.user;
    this.rodada = JSON.parse(localStorage.getItem("rodada"));
    this.graficoVendas();
    this.graficoVendasPorFornecedor();
    this.graficoVendasPorCliente();
    this.graficoVendasPorEstado();
    this.graficoVendasPorRegiao();
  },
  methods: {
    async graficoVendas() {
      this.resposta = await ServiceGraficos.vendasRep(
        this.user.representante_id,
        this.rodada.id
      );
      var top12 = this.resposta.data.map((item, index) => {
        if (index <= 12) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.vendas = top12;
      });
    },

    async graficoVendasPorFornecedor() {
      this.resposta = await ServiceGraficos.vendasPorFornecedorRep(
        this.user.representante_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorFornecedor = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorFornecedor = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorFornecedor = this.resposta.data.somaValor;
        this.vendasPorFornecedor = top5;
      });
    },

    async graficoVendasPorCliente() {
      this.resposta = await ServiceGraficos.vendasPorClienteRep(
        this.user.representante_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorCliente = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorCliente = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorCliente = this.resposta.data.somaValor;
        this.vendasPorCliente = top5;
      });
    },

    async graficoVendasPorEstado() {
      this.resposta = await ServiceGraficos.vendasPorEstadoRep(
        this.user.representante_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorEstado = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorEstado = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorEstado = this.resposta.data.somaValor;
        this.vendasPorEstado = top5;
      });
    },

    async graficoVendasPorRegiao() {
      this.resposta = await ServiceGraficos.vendasPorRegiaoRep(
        this.user.representante_id,
        this.rodada.id
      );
      var top5 = this.resposta.data.vendas.map((item, index) => {
        if (index <= 4) {
          return item;
        }
      });
      this.$nextTick(() => {
        this.listaVendasPorRegiao = this.resposta.data.vendas;
        this.totalQuantidadeVendasPorRegiao = this.resposta.data.somaQuantidade;
        this.totalValorVendasPorRegiao = this.resposta.data.somaValor;
        this.vendasPorRegiao = top5;
      });
    },
  },

  watch: {
    // 'vendas': function(val, oldVal) {
    //   if (val) {
    //     console.log(this.vendas)
    //   }
    // }
  },
};
</script>
